import { helpers, elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as selector from './tools.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { value: year, ownerDocument } = button
    const container = closest(`.${helpers.dateSelector.elements.container}`, button)
    const { dataset } = container
    const { min, max, currentDay } = dataset
    const date = new Date()
    const dateMin = date.setTime(min * 86400 * 1000)
    const dateMax = date.setTime(max * 86400 * 1000)
    const { lang } = ownerDocument
    const label = one(`.${helpers.dateSelector.elements.nav_years} .${elements.button_text}`, container)
    let currentDate

    if (currentDay) {
      const time = currentDay * 86400

      date.setTime(time * 1000)
      date.setFullYear(year)
      currentDate = date

      if (date.getTime() < dateMin) {
        currentDate = new Date(dateMin)
      }

      if (date.getTime() > dateMax) {
        currentDate = new Date(dateMax)
      }
    }

    selector.setCurrentDay(container, currentDate)
    selector.toggleView(container)

    if (label) {
      label.textContent = new Intl.DateTimeFormat(lang, {
        month: 'long',
        year: 'numeric',
        timeZone: 'GMT'
      }).format(currentDate)
    }

    selector.setDays(container, currentDate)
  }
})

export default button => {
  onClick.listen(button)
}
